/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

const MSK_OFFSET = 3;

export interface Slot {
  id: number;
  title: string;
  warnBefore: number;  // минуты с 00:00 МСК когда показываем warning
  start: number;        // минуты с 00:00 МСК когда слот начат
  end: number;        // минуты с 00:00 МСК когда слот окончен
  days: number[];     // 1–7 (1 = Monday)
}

// 0=Воскресенье ... 6=Суббота
// Нечетные - сервер ns1, четные - ns2
// Время — в минутах МСК от начала суток
export const SLOTS: Slot[] = [
  {
    days: [0, 1, 2, 3, 4, 5, 6], // каждый день 4:30 ( 2, 4 = Вт, Чт)
    start: 4 * 60 + 30,
    warnBefore: 10,
    end: 4 * 60 + 45, // 04:45
    title: 'Регламентные работы #1',
    id: 1,
  },
  // {
  //   days: [4, 5, 6], // пт-вс 11:30
  //   start: 11 * 60 + 30,
  //   warnBefore: 10,
  //   end: 11 * 60 + 35, // короткий слот 11:35
  //   title: 'Регламентные работы #2 ',
  //   id: 2,
  // },
  {
    days: [0, 1, 2, 3, 4, 5, 6], // каждый день 06:30
    start: 6 * 60 + 30,
    warnBefore: 5,
    end: 6 * 60 + 35, // короткий слот 06:35
    title: 'Регламентные работы #3',
    id: 3,
  },
  {
    days: [1, 2, 3, 4, 5, 6], // Пн–Сб
    start: 4 * 60, // 4:00
    warnBefore: 5,
    end: 4 * 60 + 10, // 4:10
    title: 'Регламентные работы #4',
    id: 4,
  },
];

function getMSKMinutes(): { minutes: number; dow: number } {
  const now = new Date();
  const mskHours = (now.getUTCHours() + MSK_OFFSET + 24) % 24;
  const minutes = mskHours * 60 + now.getUTCMinutes();

  // JS: 0=Sunday → нам нужно 1=Mon…7=Sun
  const dow = now.getUTCDay() === 0 ? 7 : now.getUTCDay();

  return { minutes, dow };
}

function getMSKDate() {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60_000;
  return new Date(utc + MSK_OFFSET * 3_600_000);
}


export function getActiveSlot(): Slot | null {
  const { minutes, dow } = getMSKMinutes();
  return (
    SLOTS.find(
      slot =>
        slot.days.includes(dow) &&
        minutes >= slot.warnBefore &&
        minutes < slot.end
    ) || null
  );
}

export function getActiveMaintenanceSlot(): Slot | null {
  const now = getMSKDate();
  const day = now.getDay();

  const minutes = now.getHours() * 60 + now.getMinutes();

  for (const slot of SLOTS) {
    if (!slot.days.includes(day)) continue;

    const warnStart = slot.start - slot.warnBefore;

    if (minutes >= warnStart && minutes < slot.end) {
      return {
        ...slot,
        warnBefore: warnStart,
      };
    }
  }
  return null;
}

export function formatHHMM(mins: number) {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
